import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { errorsAPI, errorsAPISumbmit } from 'src/app/services/apiRoutes';
import { PaginationObject } from 'src/app/models/paginationObject';
import paginationHelper from 'src/app/helpers/pagination';
import sortHelper from 'src/app/helpers/sort';
import { SortObject } from 'src/app/models/sortObject';

@Injectable()
export class ErrorService {
  constructor(public http: HttpClient) { }

  async getErrors(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        errorsAPI +
        paginationHelper.constructPagination(pageInfo) +
        sortHelper.constructSort(sortObject, true) +
        query
      )
      .toPromise();
  }

  deleteError(id: string) {
    return this.http.delete(errorsAPI + '/' + id).toPromise();
  }


  sendEditJSON(body:any){
    return this.http.put(errorsAPISumbmit,body);
  }

}
